import type { FunctionComponent } from 'react';
import NextButton from './NextButton.Container';

export interface Props {
	text: string;
	disabled?: boolean;
	onNext: () => void;
}

const NextMapLayer: FunctionComponent<Props> = (props: Props) => {
	const { text, disabled, onNext } = props;

	return (
		<NextButton
			disabled={disabled}
			onClick={onNext}
			position="absolute"
			bottom="2%"
			right="2%"
			highlighted
			highlightDelay="long"
		>
			{text}
		</NextButton>
	);
};

export default NextMapLayer;
